import { render, staticRenderFns } from "./Dashboardview.vue?vue&type=template&id=1b4e34e9&"
import script from "./Dashboardview.vue?vue&type=script&lang=js&"
export * from "./Dashboardview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports